import apiClient from '@/lib/api-client'
import type { JobPreferences, JobPreferencesCreate } from '@/types'

export const preferencesService = {
  async getJobPreferences(): Promise<JobPreferences | null> {
    const response = await apiClient.get<JobPreferences | null>('/api/v1/job-preferences', {
      // Accept either 204 (No Content) or 200 null.
      validateStatus: (status) => (status >= 200 && status < 300) || status === 204,
    })

    if (response.status === 204) {
      return null
    }
    return response.data ?? null
  },

  async createJobPreferences(payload: JobPreferencesCreate): Promise<JobPreferences> {
    const response = await apiClient.post<JobPreferences>('/api/v1/job-preferences', payload)
    return response.data
  },

  async updateJobPreferences(payload: Partial<JobPreferencesCreate>): Promise<JobPreferences> {
    const response = await apiClient.patch<JobPreferences>('/api/v1/job-preferences', payload)
    return response.data
  },
}
